import { WButton, type ButtonLookProps } from "@/components/button/WButton.tsx";
import { logoutAction } from "@/modules/api/logoutAction.ts";
import { Trans } from "@lingui/react/macro";
import { useSetAtom } from "jotai";

export function LogoutButton(props: ButtonLookProps) {
    const logout = useSetAtom(logoutAction);
    return (
        <WButton color="error" variant="border" icon="jp-power-icon" action={logout} {...props}>
            <Trans>Log out</Trans>
        </WButton>
    );
}
